<div
  class="fixed p-2 right-0 bottom-0 font-standard sm:text-sm text-[8px] z-50 pointer-events-none"
>
  v{{ version }}
</div>
